import React from 'react';
import Layout from '../components/layout/Layout';
import Sedes from '../components/sedes/Sedes';

export const SedePage = () => {
    return ( <Layout children={<Sedes />} /> )
}